// TODO when our license is finalized add a link to it.
export const TEST_LICENSE_KEY = 'This key only good for automated testing';
export const LOCAL_LICENSE_SERVER_URL = new URL('http://localhost:8080/');
export const PROD_LICENSE_SERVER_URL = new URL(
  'https://replicache-license.herokuapp.com/',
);
export const STAGING_LICENSE_SERVER_URL = new URL(
  'https://replicache-license-staging.herokuapp.com/',
);
